module.exports = __webpack_public_path__ + "img/H1.bd14048b.png";